import { useState } from 'react';

import { IsNavigationCondensedProvider } from './IsNavigationCondensed.context';

interface IsNavigationCondensedManagerProps {
  children: React.ReactNode;
}

export const IsNavigationCondensedManager: React.FC<IsNavigationCondensedManagerProps> = ({
  children,
}) => {
  const [isCondensed, setIsCondensed] = useState<boolean>(false);
  const [isForceCondensed, setIsForceCondensed] = useState<boolean>(false);

  return (
    <IsNavigationCondensedProvider
      value={{
        isNavigationCondensed: isForceCondensed ? true : isCondensed,
        isNavigationForceCondensed: isForceCondensed,
        setIsNavigationCondensed: setIsCondensed,
        setIsNavigationForceCondensed: setIsForceCondensed,
      }}
    >
      {children}
    </IsNavigationCondensedProvider>
  );
};
